export const LIGHTBOX_TYPE_SET = 'iCalendar/lightbox/LIGHTBOX_TYPE_SET'
export const FEED_NAME_SET = 'iCalendar/lightbox/FEED_NAME_SET'
export const USER_SELECTION_SET = 'iCalendar/lightbox/USER_SELECTION_SET'
export const SHARED_USER_SELECTION_SET = 'iCalendar/lightbox/SHARED_USER_SELECTION_SET'
export const LEAVE_TYPE_SELECTION_SET = 'iCalendar/lightbox/LEAVE_TYPE_SELECTION_SET'
export const INCLUDE_NOT_APPROVED_SET = 'iCalendar/lightbox/INCLUDE_NOT_APPROVED_SET'
export const DATE_RANGE_SELECITON_SET = 'iCalendar/lightbox/DATE_RANGE_SELECTION_SET'
export const CLOSE_ICAL_LIGHTBOX = 'iCalendar/lightbox/CLOSE_ICAL_LIGHTBOX'

export const CREATE_FEED_LIGHTBOX_DATA_LOAD = 'iCalendar/lightbox/CREATE_FEED_LIGHTBOX_DATA_LOAD'
export const CREATE_FEED_LIGHTBOX_DATA_LOAD_SUCCESS = 'iCalendar/lightbox/CREATE_FEED_LIGHTBOX_DATA_SUCCESS'
export const CREATE_FEED_LIGHTBOX_DATA_LOAD_FAILURE = 'iCalendar/lightbox/CREATE_FEED_LIGHTBOX_DATA_FAILURE'
export const EDIT_FEED_LIGHTBOX_DATA_LOAD = 'iCalendar/lightbox/EDIT_FEED_LIGHTBOX_DATA_LOAD'
export const EDIT_FEED_LIGHTBOX_DATA_LOAD_SUCCESS = 'iCalendar/lightbox/EDIT_FEED_LIGHTBOX_DATA_SUCCESS'
export const EDIT_FEED_LIGHTBOX_DATA_LOAD_FAILURE = 'iCalendar/lightbox/EDIT_FEED_LIGHTBOX_DATA_FAILURE'
export const EXPORT_ICAL_LIGHTBOX_DATA_LOAD = 'iCalendar/lightbox/EXPORT_ICAL_LIGHTBOX_DATA_LOAD'
export const EXPORT_ICAL_LIGHTBOX_DATA_LOAD_SUCCESS = 'iCalendar/lightbox/EXPORT_ICAL_LIGHTBOX_DATA_SUCCESS'
export const EXPORT_ICAL_LIGHTBOX_DATA_LOAD_FAILURE = 'iCalendar/lightbox/EXPORT_ICAL_LIGHTBOX_DATA_FAILURE'

export const CREATE_FEED_LOAD_DATA = 'iCalendar/lightbox/CREATE_FEED_LOAD_DATA'
export const CREATE_FEED_LOAD_DATA_SUCCESS = 'iCalendar/lightbox/CREATE_FEED_LOAD_DATA_SUCCESS'
export const CREATE_FEED_LOAD_DATA_FAILURE = 'iCalendar/lightbox/CREATE_FEED_LOAD_DATA_FAILURE'

export const EDIT_FEED_LOAD_DATA = 'iCalendar/lightbox/EDIT_FEED_LOAD_DATA'
export const EDIT_FEED_LOAD_DATA_SUCCESS = 'iCalendar/lightbox/EDIT_FEED_LOAD_DATA_SUCCESS'
export const EDIT_FEED_LOAD_DATA_FAILURE = 'iCalendar/lightbox/EDIT_FEED_LOAD_DATA_FAILURE'

export const EXPORT_ICAL_LOAD_DATA = 'iCalendar/lightbox/EXPORT_ICAL_LOAD_DATA'
export const EXPORT_ICAL_LOAD_DATA_SUCCESS = 'iCalendar/lightbox/EXPORT_ICAL_LOAD_DATA_SUCCESS'
export const EXPORT_ICAL_LOAD_DATA_FAILURE = 'iCalendar/lightbox/EXPORT_ICAL_LOAD_DATA_FAILURE'



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/actionTypes.js